<template>
  <div class="order-details">
    <ul>
      <li
        :class="onLi==item?'div-li div-onli':' div-li'"
        v-for="(item,index) in liList"
        :key="index"
        @click="checkLi(item)"
      >{{item}}</li>
    </ul>
    <div v-if="onLi=='订单详情'">
      <van-field v-model="orderData.orderId" label="订单编号：" readonly />
      <van-field v-model="orderData.productName" label="产品名称：" readonly />
      <van-field v-model="orderData.cusName" label="客户姓名：" readonly />
      <van-field v-model="orderData.idCard" label="客户身份证：" readonly />
      <van-field v-model="orderData.cusMobile" label="客户手机号：" readonly />
      <van-field
        readonly
        clickable
        name="area"
        :value="orderData.cityName"
        label="所在省市："
        @click="showArea = true"
      />
      <van-field v-model="['审批通过','审批不通过','待审批'][orderData.approvalStatus]" label="审核状态：" readonly />
      <van-field v-model="orderData.orderStatusName" label="发佣状态：" readonly />
      <van-field v-model="orderData.loanTypeDesc" label="放款类型：" readonly />
      <van-field v-model="orderData.productRate" label="借贷利率（%）：" readonly />
      <van-field v-model="orderData.actualAmount" label="放款金额（万元）：" readonly />
      <!-- <van-field v-model="orderData.loanRate" label="放款佣金率（%）：" readonly /> -->
      <van-field v-model="orderData.loanRate" label="总佣金率（%）：" readonly />
      <van-field v-model="orderData.totalCommission" label="佣金金额（元）：" readonly />
      <van-field v-model="orderData.createTime" label="进件时间：" readonly />
      <van-field v-model="orderData.settlementEntryTime" label="放款时间：" readonly />
      <van-field v-model="orderData.brokerName" label="经纪人姓名：" readonly />
      <van-field
        readonly
        v-model="orderData.remark"
        type="textarea"
        label="备注："
        autosize
        show-word-limit
        rows="3"
      />
    </div>
    <div v-if="onLi=='订单过程'">
      <van-steps direction="vertical"  active-color="#FC6E09" :active="active">
        <van-step v-for="(item,index) in stepList" :key="index">
          <p>{{item.createTime}} <span class="step-span"> {{item.name}}</span></p>
          <p class="step-p">{{item.statusName}}</p>
        </van-step>
      </van-steps>
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
export default {
  data() {
    return {
      onLi: '订单详情',
      liList: ['订单详情', '订单过程'],
      active:null,
      orderData:{},
      stepList:[
          {//步骤条数据
            time:'2022-04-24 14:23:34',
            stage:'提交进件信息',
            name:'张三',
          },
          {//步骤条数据
            time:'2022-05-14 14:23:34',
            stage:'成功放款',
            name:'贷款银行名称',
          },
          {//步骤条数据
            time:'2022-05-23 14:23:34',
            stage:'审批通过',
            name:'审批人名称',
          },
          {//步骤条数据
            time:'2022-05-23 14:23:34',
            stage:'发放佣金',
            name:'发放佣金人名称',
          },

      ],
    }
  },
  mounted(){
    this.getData()
  },
  methods: {
    checkLi(item) {
      this.onLi = item
      if(item=='订单过程'){
        this.orderProcess()
      }
    },
    getData(){
      let data={
        orderId:this.$route.query.id,
        orderType:'loan'
      }
      this.$fetchGet(URLTB.getOrderDetail.url, data).then(res=>{
        if(res.data.code==20000){
          this.orderData=res.data.data
        }
      })
    },
    orderProcess(){
      let that=this
      let data={
        // orderId:this.$route.query.id,
        orderId:'2535716',
      }
      that.$fetchGet(URLTB.getOrderProcess.url, data).then(res=>{
        if(res.data.code==20000){
          that.stepList=res.data.data
          that.active=(that.stepList.length) - 1
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-details {
  height: 100vh;
  background: #ffffff;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  overflow: scroll;
  ul {
    display: flex;
    .div-li {
      width: 188px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      background: url("../../assets/publicImg/li-bg1.png") no-repeat 50%;
      background-size: 100% 100%;
    }
    .div-onli {
      background: url("./img/bg2.png") no-repeat 50%;
      color: #ffffff;
    }
  }
  .van-cell {
    font-size: 12px;
    /deep/.van-field__label {
      width: 111px;
    }
  }
  .van-step{
    // line-height: 28px;
    .step-span{
      padding-left: 10px;
    }
    .step-p{
      // line-height: 30px;
      padding-top: 10px;
    }
  }
}
</style>